export const screenSize = {
  extraSmall: '448px',
  small: '600px',
  medium: '832px',
  large: '1088px',
  extraLarge: '1280px',
};

export const color = {
  ivory: '#fdfdf2',
  white: '#fff',
  black: '#000',
  blue: '#4a8cca',
  orange: '#ffaa5b',
  blackOlive: '#3c3c3a',
  devoteam: '#f8485e',
  foodType: {
    meat: '#fca2ae',
    veg: '#8ab8a5',
    vegan: '#72f7c0',
    fish: '#6f9eca',
    misc: '#795b8c',
  },
};
